import { formatDateHourLocale, formatDateLocale } from '@/app/utils/commonFunctions'
import { LuxIcon, LuxIconBadge, LuxPhotoCard, Color } from '@lux/wardrobe-lib'
import { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { Swiper, SwiperSlide } from 'swiper/react'
import './PhotoSlider.scss'
import moment from 'moment'

export interface PhotoSliderProps {
    slide: number
    uploadedImageList: any[]
    mobileImageList: any[]
    hideAddPhoto?: boolean
    onAddPhoto: () => void
    onDownload: () => void
    onTag: (photo: { name: string; url: string }) => void
    onEdit: (photo: { name: string; url: string }) => void
    onDelete: () => void
    previousImage: () => void
    nextImage: () => void
    onExpandImage: (photo: { name: string; url: string }) => void
    onSwiperActiveIndexChange: (swiper: any) => void
}

const PhotoSlider = ({
    slide,
    uploadedImageList,
    mobileImageList,
    hideAddPhoto,
    onDownload,
    onTag,
    onEdit,
    onAddPhoto,
    onExpandImage,
    previousImage,
    nextImage,
    onSwiperActiveIndexChange,
}: PhotoSliderProps) => {
    const componentClass = 'smart-modals-photo-slider'
    const intl = useIntl()
    const swiperRef = useRef(null)

    const ctaIconSize = 48

    useEffect(() => {
        swiperRef.current.swiper.slideTo(slide)
    }, [slide, uploadedImageList])

    return (
        <div className={`${componentClass}`}>
            <div className={`${componentClass}__expand`}>
                <div className="text">
                    {slide + 1}/{uploadedImageList.length}
                </div>
                <div>
                    {!hideAddPhoto && (
                        <div className={`${componentClass}__add-photo`} onClick={onAddPhoto}>
                            <LuxIconBadge
                                icon="plus"
                                size={16}
                                color={Color.BLUE}
                                backgroundColor={Color.BG_LIGHT_BLUE}
                            />
                            <span className="link-mini">
                                {intl.formatMessage({
                                    id: 'ph2.modals.photo.slider.add.photo',
                                    defaultMessage: 'Add photo',
                                })}
                            </span>
                        </div>
                    )}
                </div>
                {hideAddPhoto && <div></div>}
                <div className={`${componentClass}__expand-icon`}>
                    {!!uploadedImageList[slide] && (
                        <LuxIcon
                            icon="expand"
                            size={22}
                            onClick={onExpandImage.bind(null, {
                                url: uploadedImageList[slide]?.url,
                                name: uploadedImageList[slide]?.name,
                                id: uploadedImageList[slide]?.attachmentId,
                                ext: uploadedImageList[slide]?.ext,
                            })}
                        />
                    )}
                </div>
            </div>
            {!!uploadedImageList[slide] && (
                <div className={`${componentClass}__photo-disclaimer text`}>
                    {moment(
                        uploadedImageList[slide]?.date ? uploadedImageList[slide]?.date : undefined
                    ).format('L LT')}
                </div>
            )}
            <div className={`${componentClass}__photo`}>
                <img src={uploadedImageList[slide]?.url} />
            </div>
            <div className={`${componentClass}__photo-mobile`}>
                <Swiper
                    ref={swiperRef}
                    spaceBetween={15}
                    slidesPerView={1}
                    onActiveIndexChange={onSwiperActiveIndexChange}>
                    {mobileImageList.map((image, i) => {
                        return (
                            <SwiperSlide key={i} virtualIndex={slide}>
                                <div key={i} className={`${componentClass}__card`}>
                                    <LuxPhotoCard {...image} key={i} />
                                </div>
                            </SwiperSlide>
                        )
                    })}
                </Swiper>
            </div>
            {!!uploadedImageList[slide] && (
                <div className={`${componentClass}__photo-cta-container`}>
                    <div>
                        {uploadedImageList.length > 1 && slide > 0 && (
                            <div
                                className={`${componentClass}__photo-slider__left`}
                                onClick={previousImage}>
                                <LuxIconBadge icon="caret-left" />
                                {/* <div className="text">
                                {slide + 1}/{uploadedImageList.length} {macroArea}
                            </div> */}
                            </div>
                        )}
                    </div>
                    <div className={`${componentClass}__photo-cta`}>
                        {uploadedImageList[slide]._id && (
                            <div onClick={onDownload}>
                                <LuxIconBadge icon="download" size={ctaIconSize} />
                            </div>
                        )}
                        <div
                            onClick={onTag.bind(null, {
                                url: uploadedImageList[slide]?.url,
                                name: uploadedImageList[slide]?.name,
                                id: uploadedImageList[slide]?.attachmentId,
                            })}>
                            <LuxIconBadge icon="label" size={ctaIconSize} />
                        </div>
                        <div
                            onClick={onEdit.bind(null, {
                                url: uploadedImageList[slide]?.url,
                                name: uploadedImageList[slide]?.name,
                                id: uploadedImageList[slide]?.attachmentId,
                                ext: uploadedImageList[slide]?.ext,
                            })}>
                            <LuxIconBadge icon="pencil" size={ctaIconSize} />
                        </div>
                        {/* <div
                        className="trash"
                        onClick={onDelete}
                    >
                        <LuxIconBadge icon="trash" />
                    </div> */}
                    </div>
                    <div>
                        {uploadedImageList.length > 1 && slide + 1 < uploadedImageList.length && (
                            <div
                                className={`${componentClass}__photo-slider__right`}
                                onClick={nextImage}>
                                <LuxIconBadge icon="caret-right" />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    )
}

export default PhotoSlider
